import React, { useState } from "react";
import TableSearchInput from "../TableSearchInput";
import { Box } from "@mui/material";

const ZoneSearchInput = ({ updateSearchValue, updateRefreshKey }) => {
  const [query, setQuery] = useState("");

  const handleInputChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (value === "") {
      updateSearchValue("");
      updateRefreshKey((key) => key + 1);
    } else {
      updateSearchValue(value.trim());
    }
  };

  return (
    <Box sx={{ width: "250px"}}>
      <TableSearchInput
        searchQuery={query}
        onSearchChange={handleInputChange}
        tooltip="Search Zone, Subzone"
        placeholder="Search Zone, Subzone"
      />
    </Box>
  );
};

export default ZoneSearchInput;
